import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">汗汗漫画</Link>
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              汗汗漫画主打下拉式漫画连续阅读体验，滚动观看不间断，漫画下拉即可加载全集。免费流畅观看各类漫画，感受全新阅读方式。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/rexue" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/rexue" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</Link></li>
              <li><Link to="/category/lianai" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">搞笑漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系方式</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                <span>contact@hanhancomic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 汗汗漫画 HanHanComic.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}